import apiClient from '@u/apiClient'

export default {
  fetchFamilySpaceData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      apiClient
        .get(`dossier/${payload.dossier_id}/family-space`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateFamilySpaceData({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      apiClient
        .put(`dossier/${payload.dossier_id}/family-space`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
